module.exports = __webpack_public_path__ + "imgs/PaceIndy.bf97df9af38166ab0ff15b8df3ff86cf.png";